export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  GTQ: 'Q',
  PAB: 'B/.',
};

export const percentFields = [
  { name: 'return_of_investment', label: 'ROI (Retorno de inversión)' },
  { name: 'internal_rate_return', label: 'IRR (Tasa interna de retorno)' },
  { name: 'earnings_percentage', label: 'Porcentaje de ganancias' },
] as const;

export const moneyFields = [
  { name: 'reserve_price', label: 'Precio de reserva' },
  { name: 'down_payment_price', label: 'Precio de prima' },
] as const;
